import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { catchError, Observable, tap, throwError } from "rxjs";
import { LoaderService } from "../services/loader.service";
import { inject } from "@angular/core";
import { clientDetection } from "../globalFunctions/globalFunctions";

export function loaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    const loaderService = inject(LoaderService);

    // Only start loading if request is to insight api
    if (req.url.startsWith(environment.API_URL[clientDetection()])) {
        loaderService.startLoading();
    }
    
    return next(req)
        .pipe(catchError((error: HttpErrorResponse) => {
            loaderService.stopLoading();
            return throwError(() => error);
        }))
        .pipe(tap(event => {
            if (event.type === HttpEventType.Response) {
                loaderService.stopLoading();
            }
        }));
}